import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import cx from 'classnames';
import s from './HistoryAlarms.css';

import HistoryAlarm from './HistoryAlarm';
import InfiniteScrollWithLoadMore from '../InfiniteScroll';

const MAX_NUMBER_OF_AUTOLOADS = 1;

class HistoryAlarms extends React.Component {
  render () {
    const alertsPaging = this.props.alertsPaging;
    const hasMore =
      alertsPaging.get('itemsPerPage') * alertsPaging.get('currentPage') <
      alertsPaging.get('itemsCount');

    const wrappedClasses = cx(
      s.listBordered,
      s.listBordered__large,
      s.listBordered__flat);
    const numberOlderItemsFetched = alertsPaging.get('numberOlderItemsFetched');
    const user = alertsPaging.get('user')
    return (
      <InfiniteScrollWithLoadMore
        loadMore={this.props.getNextAlertPage}
        hasMore={hasMore}
        showLoadMore={numberOlderItemsFetched >= MAX_NUMBER_OF_AUTOLOADS}
        className={wrappedClasses}
      >
        {this.props.alerts.valueSeq().map(alert =>
          <HistoryAlarm alert={alert} key={alert.get('id')} user={user}/>
        )}
      </InfiniteScrollWithLoadMore>

    )
  }
}

HistoryAlarms.propTypes = {
  alertsPaging: PropTypes.object.isRequired,
  alerts: PropTypes.object.isRequired,
  getNextAlertPage: PropTypes.func.isRequired,
};

const mapState = state => ({
  alerts: state.alerts,
  alertsPaging: state.alertsPaging,
});

export default compose(withStyles(s), connect(mapState, null))(HistoryAlarms);



// WEBPACK FOOTER //
// ./src/components/HistoryAlarms/HistoryAlarms.js